var _line, _line2, _line3, _line4, _line5, _path, _path2, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _path3, _line32, _line33, _line34, _line35, _line36, _path4, _rect, _rect2, _line37, _path5, _path6, _path7, _path8, _line38, _line39, _line40, _line41, _line42, _path9, _path10, _rect3, _rect4, _line43, _path11, _path12, _path13, _path14, _line44, _line45, _line46, _line47, _line48, _line49, _path15, _rect5, _rect6, _line50, _path16, _path17, _path18, _path19, _line51, _path20, _line52, _line53, _line54, _line55, _path21, _rect7, _rect8, _line56, _path22, _path23, _path24, _path25, _line57, _line58, _line59, _line60, _line61, _line62, _rect9, _rect10, _line63, _path26, _path27, _path28, _path29, _path30, _line64, _line65, _line66, _line67, _line68, _line69, _rect11, _rect12, _line70, _path31, _path32, _path33, _path34, _path35, _line71, _line72, _rect13, _rect14, _line73, _line74, _line75, _line76, _path36, _path37, _path38, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingMapStandart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 810,
    height: 805,
    viewBox: "0 0 810 805",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.9932,
    y1: 30.24,
    x2: 29.9931,
    y2: 739.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 779.136,
    y1: 82.5176,
    x2: 779.136,
    y2: 739.089,
    stroke: "#404040",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9932,
    y1: 29.24,
    x2: 709.863,
    y2: 29.24,
    stroke: "#404040",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 404.032,
    y1: 738.09,
    x2: 778.136,
    y2: 738.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9932,
    y1: 738.09,
    x2: 276.837,
    y2: 738.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4033 1.88599H253.455",
    stroke: "#404040",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.456 1.88599H521.875",
    stroke: "#404040",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 522,
    y1: 2,
    x2: 709.987,
    y2: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 709.862,
    y1: 1.77222,
    x2: 807.129,
    y2: 1.77222,
    stroke: "#404040",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 100.943,
    y1: 29.354,
    x2: 100.943,
    y2: 1.00002,
    stroke: "#404040",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 287.06,
    y1: 29.354,
    x2: 287.06,
    y2: 2.77215,
    stroke: "#404040",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 522.746,
    y1: 29.354,
    x2: 522.746,
    y2: 2.77215,
    stroke: "#404040",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 708.862,
    y1: 29.354,
    x2: 708.862,
    y2: 2.77215,
    stroke: "#404040",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 708.992,
    y1: 30.24,
    x2: 708.992,
    y2: 84.2898,
    stroke: "#404040",
    strokeWidth: 2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 709.862,
    y1: 83.2898,
    x2: 779.072,
    y2: 83.2898,
    stroke: "#404040",
    strokeWidth: 2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 779.072,
    y1: 83.2898,
    x2: 809,
    y2: 83.2898,
    stroke: "#404040",
    strokeWidth: 2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 780.007,
    y1: 475.815,
    x2: 808.065,
    y2: 475.815,
    stroke: "#404040",
    strokeWidth: 2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 779.072,
    y1: 651.256,
    x2: 807.13,
    y2: 651.256,
    stroke: "#404040",
    strokeWidth: 2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 779.072,
    y1: 259.616,
    x2: 807.13,
    y2: 259.616,
    stroke: "#404040",
    strokeWidth: 2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 808.129,
    y1: 83.4038,
    x2: 808.129,
    y2: 260.616,
    stroke: "#404040",
    strokeWidth: 2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 808.129,
    y1: 475.043,
    x2: 808.129,
    y2: 652.256,
    stroke: "#404040",
    strokeWidth: 2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 82.5176,
    x2: 808,
    y2: 0.999878,
    stroke: "#404040",
    strokeWidth: 2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 66.4033,
    y1: 2,
    x2: 0.935112,
    y2: 1.99999,
    stroke: "#404040",
    strokeWidth: 2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 0.999967,
    y2: 765.671,
    stroke: "#404040",
    strokeWidth: 2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 275.966,
    y1: 739.09,
    x2: 275.966,
    y2: 765.671,
    stroke: "#404040",
    strokeWidth: 2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 405.032,
    y1: 739.09,
    x2: 405.032,
    y2: 765.671,
    stroke: "#404040",
    strokeWidth: 2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1.87061,
    y1: 764.671,
    x2: 274.967,
    y2: 764.671,
    stroke: "#404040",
    strokeWidth: 2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 405.903,
    y1: 764.671,
    x2: 807.129,
    y2: 764.671,
    stroke: "#404040",
    strokeWidth: 2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 808.129,
    y1: 260.616,
    x2: 808.129,
    y2: 475.043,
    stroke: "#404040",
    strokeWidth: 2
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 808.129,
    y1: 652.256,
    x2: 808.129,
    y2: 765.672,
    stroke: "#404040",
    strokeWidth: 2
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 793.601,
    y1: 476.815,
    x2: 793.601,
    y2: 652.255,
    stroke: "#404040"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 794.101,
    y1: 476.815,
    x2: 794.101,
    y2: 652.255,
    stroke: "#404040",
    strokeWidth: 2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 794.101,
    y1: 83.4038,
    x2: 794.101,
    y2: 258.844,
    stroke: "#404040",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.008 16.063H288.06M522.811 16.063H709.863",
    stroke: "#404040",
    strokeWidth: 2
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 29.9282,
    y1: 656.572,
    x2: 134.677,
    y2: 656.572,
    stroke: "#404040",
    strokeWidth: 2
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 30.9282,
    y1: 657.572,
    x2: 30.9282,
    y2: 739.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 30.8633,
    y1: 738.09,
    x2: 239.426,
    y2: 738.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 238.426,
    y1: 737.317,
    x2: 238.426,
    y2: 615.927,
    stroke: "#404040",
    strokeWidth: 2
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 237.556,
    y1: 616.927,
    x2: 156.189,
    y2: 616.927,
    stroke: "#404040",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.123 616.37C157.123 645.2 135.825 656.752 134.316 656.719",
    stroke: "#404040",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 107.62,
    y: 672.749,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 133.807,
    y: 678.951,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 142.159,
    y1: 706.077,
    x2: 158.059,
    y2: 706.077,
    stroke: "#404040",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.34 616.927H238.427V649.483H198.34V616.927Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M220.847 626.087V643.243H218.679V628.794L214.308 630.388V628.431L220.507 626.087H220.847Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.261 609.729C116.428 610.174 116.598 610.979 116.754 612.133C116.907 613.265 117.039 614.662 117.151 616.244C117.376 619.408 117.521 623.272 117.614 627.159C117.779 634.066 117.78 641.011 117.778 644.167H112.186C112.186 641.406 112.179 635.094 112.051 628.806C111.977 625.186 111.864 621.565 111.688 618.629C111.6 617.163 111.496 615.856 111.372 614.802C111.252 613.782 111.104 612.9 110.897 612.346C109.579 608.824 107.645 605.618 105.2 602.913C102.756 600.208 99.8485 598.056 96.641 596.586C93.4331 595.115 89.9908 594.357 86.5115 594.357C83.0322 594.357 79.5898 595.115 76.382 596.586C73.1744 598.056 70.267 600.208 67.8226 602.913C65.3784 605.618 63.4442 608.824 62.1261 612.346C61.9189 612.9 61.7706 613.782 61.6507 614.802C61.5268 615.856 61.4228 617.163 61.335 618.629C61.1592 621.565 61.0456 625.186 60.9721 628.806C60.8445 635.094 60.8372 641.406 60.8375 644.167H55.2455C55.2436 641.011 55.2442 634.066 55.4094 627.159C55.5023 623.272 55.6471 619.408 55.8718 616.244C55.9841 614.662 56.1157 613.265 56.2691 612.133C56.4254 610.979 56.5955 610.174 56.7618 609.729C58.3884 605.383 60.7703 601.441 63.7672 598.124C66.7639 594.807 70.3159 592.183 74.2175 590.394C78.1188 588.606 82.2959 587.687 86.5115 587.687C90.727 587.687 94.9042 588.606 98.8054 590.394C102.707 592.183 106.259 594.807 109.256 598.124C112.253 601.441 114.635 605.383 116.261 609.729Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.185 613.421C108.101 610.007 103.014 606.099 98.9838 604.252C94.954 602.405 90.0591 601.725 85.6973 601.725C81.3355 601.725 77.0164 602.676 72.9866 604.523C68.9569 606.37 64.9221 610.007 61.8379 613.421",
    stroke: "#404040",
    strokeWidth: 2
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 60.8892,
    y1: 644.167,
    x2: 112.135,
    y2: 644.167,
    stroke: "#404040",
    strokeWidth: 2
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 104.749,
    y2: -1,
    transform: "matrix(1 0 0 -1 28.9932 464.41)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 81.5177,
    y2: -1,
    transform: "matrix(0 -1 -1 0 28.9932 464.41)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 208.563,
    y2: -1,
    transform: "matrix(1 0 0 -1 29.9282 382.893)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 121.39,
    y2: -1,
    transform: "matrix(-5.61775e-08 1 1 3.40116e-08 238.491 384.665)",
    stroke: "#404040",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.621 505.169H155.253",
    stroke: "#404040",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.082 505.646C156.082 476.815 134.784 465.263 133.275 465.297",
    stroke: "#404040",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 106.685,
    y: 410.475,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132.872,
    y: 416.677,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 141.225,
    y1: 443.803,
    x2: 157.124,
    y2: 443.803,
    stroke: "#404040",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.47 470.727H236.556V503.283H196.47V470.727Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M223.031 497.034V498.815H211.863V497.257L217.453 491.034C218.141 490.269 218.672 489.62 219.047 489.089C219.43 488.55 219.695 488.069 219.844 487.647C220 487.218 220.078 486.78 220.078 486.335C220.078 485.772 219.961 485.265 219.727 484.812C219.5 484.351 219.164 483.983 218.719 483.71C218.273 483.437 217.734 483.3 217.102 483.3C216.344 483.3 215.711 483.448 215.203 483.745C214.703 484.034 214.328 484.44 214.078 484.964C213.828 485.487 213.703 486.089 213.703 486.769H211.535C211.535 485.808 211.746 484.929 212.168 484.132C212.59 483.335 213.215 482.702 214.043 482.233C214.871 481.757 215.891 481.519 217.102 481.519C218.18 481.519 219.102 481.71 219.867 482.093C220.633 482.468 221.219 482.999 221.625 483.687C222.039 484.366 222.246 485.163 222.246 486.077C222.246 486.577 222.16 487.085 221.988 487.601C221.824 488.108 221.594 488.616 221.297 489.124C221.008 489.632 220.668 490.132 220.277 490.624C219.895 491.116 219.484 491.601 219.047 492.077L214.477 497.034H223.031Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.326 512.253C115.492 511.809 115.662 511.003 115.819 509.849C115.972 508.717 116.104 507.321 116.216 505.738C116.441 502.574 116.586 498.71 116.679 494.823C116.844 487.916 116.845 480.972 116.843 477.815H111.251C111.251 480.577 111.244 486.889 111.116 493.176C111.042 496.796 110.929 500.418 110.753 503.353C110.665 504.82 110.561 506.126 110.437 507.18C110.317 508.201 110.169 509.083 109.962 509.636C108.644 513.158 106.71 516.364 104.265 519.069C101.821 521.774 98.9135 523.926 95.7059 525.397C92.4981 526.867 89.0557 527.626 85.5764 527.626C82.0971 527.626 78.6548 526.867 75.4469 525.397C72.2394 523.926 69.3319 521.774 66.8875 519.069C64.4433 516.364 62.5092 513.158 61.1911 509.636C60.9839 509.083 60.8355 508.201 60.7156 507.18C60.5918 506.126 60.4878 504.82 60.3999 503.353C60.2241 500.418 60.1106 496.796 60.0371 493.176C59.9094 486.889 59.9022 480.577 59.9025 477.815H54.3104C54.3085 480.972 54.3092 487.916 54.4743 494.823C54.5672 498.71 54.712 502.574 54.9367 505.738C55.0491 507.321 55.1807 508.717 55.334 509.849C55.4904 511.003 55.6604 511.809 55.8267 512.253C57.4533 516.599 59.8353 520.542 62.8321 523.859C65.8288 527.175 69.3809 529.8 73.2825 531.588C77.1837 533.377 81.3609 534.295 85.5764 534.295C89.792 534.295 93.9691 533.377 97.8704 531.588C101.772 529.8 105.324 527.175 108.321 523.859C111.318 520.542 113.7 516.599 115.326 512.253Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.25 508.562C107.166 511.975 102.079 515.883 98.0487 517.73C94.019 519.578 89.1241 520.258 84.7623 520.258C80.4005 520.258 76.0814 519.307 72.0516 517.459C68.0218 515.612 63.9871 511.975 60.9028 508.562",
    stroke: "#404040",
    strokeWidth: 2
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 51.2453,
    y2: -1,
    transform: "matrix(1 0 0 -1 59.9541 476.815)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9932,
    y1: 302.147,
    x2: 133.742,
    y2: 302.147,
    stroke: "#404040",
    strokeWidth: 2
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 29.9932,
    y1: 303.147,
    x2: 29.9932,
    y2: 384.665,
    stroke: "#404040",
    strokeWidth: 2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 29.9282,
    y1: 383.665,
    x2: 238.491,
    y2: 383.665,
    stroke: "#404040",
    strokeWidth: 2
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 237.491,
    y1: 382.893,
    x2: 237.491,
    y2: 261.502,
    stroke: "#404040",
    strokeWidth: 2
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 236.621,
    y1: 262.502,
    x2: 155.253,
    y2: 262.502,
    stroke: "#404040",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.189 261.912C156.189 290.742 134.89 302.294 133.381 302.261",
    stroke: "#404040",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106.685,
    y: 318.324,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 132.872,
    y: 324.527,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 141.225,
    y1: 351.653,
    x2: 157.124,
    y2: 351.653,
    stroke: "#404040",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.405 350.222H237.491V382.779H197.405V350.222Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M215.016 366.941H216.562C217.32 366.941 217.945 366.816 218.438 366.566C218.938 366.308 219.309 365.961 219.551 365.523C219.801 365.078 219.926 364.578 219.926 364.023C219.926 363.367 219.816 362.816 219.598 362.371C219.379 361.926 219.051 361.59 218.613 361.363C218.176 361.136 217.621 361.023 216.949 361.023C216.34 361.023 215.801 361.144 215.332 361.386C214.871 361.621 214.508 361.957 214.242 362.394C213.984 362.832 213.855 363.347 213.855 363.941H211.688C211.688 363.074 211.906 362.285 212.344 361.574C212.781 360.863 213.395 360.297 214.184 359.875C214.98 359.453 215.902 359.242 216.949 359.242C217.98 359.242 218.883 359.426 219.656 359.793C220.43 360.152 221.031 360.691 221.461 361.41C221.891 362.121 222.105 363.008 222.105 364.07C222.105 364.5 222.004 364.961 221.801 365.453C221.605 365.937 221.297 366.39 220.875 366.812C220.461 367.234 219.922 367.582 219.258 367.855C218.594 368.121 217.797 368.254 216.867 368.254H215.016V366.941ZM215.016 368.722V367.422H216.867C217.953 367.422 218.852 367.551 219.562 367.808C220.273 368.066 220.832 368.41 221.238 368.84C221.652 369.269 221.941 369.742 222.105 370.258C222.277 370.765 222.363 371.273 222.363 371.781C222.363 372.578 222.227 373.285 221.953 373.902C221.688 374.519 221.309 375.043 220.816 375.472C220.332 375.902 219.762 376.226 219.105 376.445C218.449 376.664 217.734 376.773 216.961 376.773C216.219 376.773 215.52 376.668 214.863 376.457C214.215 376.246 213.641 375.941 213.141 375.543C212.641 375.136 212.25 374.64 211.969 374.054C211.688 373.461 211.547 372.785 211.547 372.027H213.715C213.715 372.621 213.844 373.14 214.102 373.586C214.367 374.031 214.742 374.379 215.227 374.629C215.719 374.871 216.297 374.992 216.961 374.992C217.625 374.992 218.195 374.879 218.672 374.652C219.156 374.418 219.527 374.066 219.785 373.597C220.051 373.129 220.184 372.539 220.184 371.828C220.184 371.117 220.035 370.535 219.738 370.082C219.441 369.621 219.02 369.281 218.473 369.062C217.934 368.836 217.297 368.722 216.562 368.722H215.016Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.326 255.305C115.492 255.749 115.662 256.554 115.819 257.709C115.972 258.84 116.104 260.237 116.216 261.819C116.441 264.984 116.586 268.847 116.679 272.734C116.844 279.641 116.845 286.586 116.843 289.742H111.251C111.251 286.981 111.244 280.669 111.116 274.381C111.042 270.761 110.929 267.14 110.753 264.205C110.665 262.738 110.561 261.432 110.437 260.378C110.317 259.357 110.169 258.475 109.962 257.921C108.644 254.4 106.71 251.194 104.265 248.489C101.821 245.783 98.9135 243.631 95.7059 242.161C92.4981 240.691 89.0557 239.932 85.5764 239.932C82.0971 239.932 78.6548 240.691 75.4469 242.161C72.2394 243.631 69.3319 245.783 66.8875 248.489C64.4433 251.194 62.5092 254.4 61.1911 257.921C60.9839 258.475 60.8355 259.357 60.7156 260.378C60.5918 261.432 60.4878 262.738 60.3999 264.205C60.2241 267.14 60.1106 270.761 60.0371 274.381C59.9094 280.669 59.9022 286.981 59.9025 289.742H54.3104C54.3085 286.586 54.3092 279.641 54.4743 272.734C54.5672 268.847 54.712 264.984 54.9367 261.819C55.0491 260.237 55.1807 258.84 55.334 257.709C55.4904 256.554 55.6604 255.749 55.8267 255.305C57.4533 250.959 59.8353 247.016 62.8321 243.699C65.8288 240.383 69.3809 237.758 73.2825 235.969C77.1837 234.181 81.3609 233.262 85.5764 233.262C89.792 233.262 93.9691 234.181 97.8704 235.969C101.772 237.758 105.324 240.383 108.321 243.699C111.318 247.016 113.7 250.959 115.326 255.305Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.25 258.996C107.166 255.582 102.079 251.674 98.0487 249.827C94.019 247.98 89.1241 247.3 84.7623 247.3C80.4005 247.3 76.0814 248.251 72.0516 250.098C68.0218 251.945 63.9871 255.582 60.9028 258.996",
    stroke: "#404040",
    strokeWidth: 2
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 59.9541,
    y1: 289.742,
    x2: 111.199,
    y2: 289.742,
    stroke: "#404040",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M381.521 29.354V128.593",
    stroke: "#404040",
    strokeWidth: 2
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 86.0439,
    y2: -1,
    transform: "matrix(1 0 0 -1 382.521 29.354)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 197.592,
    y2: -1,
    transform: "matrix(0 1 1 0 468.565 30.24)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 128.131,
    y2: -1,
    transform: "matrix(-1 -5.04227e-08 -3.78934e-08 1 466.694 227.832)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 77.0874,
    y2: -1,
    transform: "matrix(0 -1 -1 0 338.563 226.06)",
    stroke: "#404040",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M381.586 128.15C375.965 153.487 340.902 149.415 339.031 149.858",
    stroke: "#404040",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 389.132,
    y: 139.34,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 415.319,
    y: 145.542,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 423.672,
    y1: 172.668,
    x2: 439.572,
    y2: 172.668,
    stroke: "#404040",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M341.435 193.389H381.521V225.946H341.435V193.389Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.542 213.964V215.745H353.214V214.468L360.854 202.643H362.624L360.726 206.065L355.675 213.964H365.542ZM363.163 202.643V219.706H360.995V202.643H363.163Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M331.97 111.085C332.455 111.247 333.318 111.41 334.538 111.558C335.737 111.704 337.215 111.829 338.887 111.936C342.231 112.149 346.312 112.286 350.416 112.374C357.749 112.532 365.122 112.531 368.427 112.53V107.337C365.543 107.337 358.839 107.331 352.161 107.209C348.341 107.14 344.521 107.032 341.426 106.866C339.879 106.782 338.503 106.684 337.395 106.567C336.318 106.454 335.403 106.314 334.836 106.124C331.133 104.88 327.758 103.053 324.905 100.74C322.053 98.4267 319.776 95.6689 318.218 92.6173C316.658 89.5646 315.851 86.2825 315.851 82.9606C315.851 79.6388 316.658 76.3567 318.218 73.3039C319.776 70.2523 322.053 67.4946 324.905 65.1811C327.758 62.8679 331.133 61.0411 334.836 59.7974C335.403 59.6069 336.318 59.4677 337.395 59.354C338.503 59.2372 339.879 59.1388 341.426 59.0557C344.521 58.8893 348.341 58.7817 352.161 58.7121C358.839 58.5905 365.543 58.5843 368.427 58.5846V53.392C365.122 53.3901 357.749 53.3899 350.416 53.5472C346.312 53.6353 342.231 53.7725 338.887 53.9856C337.215 54.0922 335.737 54.2171 334.538 54.3629C333.318 54.5113 332.455 54.6739 331.97 54.8365C327.368 56.3826 323.198 58.6449 319.694 61.4865C316.191 64.3279 313.426 67.6899 311.544 71.3734C309.664 75.0558 308.7 78.9924 308.7 82.9606C308.7 86.9289 309.664 90.8654 311.544 94.5478C313.426 98.2314 316.191 101.593 319.694 104.435C323.198 107.276 327.368 109.539 331.97 111.085Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M335.918 106.336C332.315 103.414 328.19 98.5947 326.24 94.7769C324.29 90.9591 323.573 86.3216 323.573 82.1893C323.573 78.0569 324.576 73.965 326.526 70.1472C328.476 66.3295 332.315 62.507 335.918 59.585",
    stroke: "#404040",
    strokeWidth: 2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 48.5496,
    y2: -1,
    transform: "matrix(0 1 1 0 369.427 58.686)",
    stroke: "#404040",
    strokeWidth: 2
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 567.703,
    y1: 378.348,
    x2: 672.452,
    y2: 378.348,
    stroke: "#404040",
    strokeWidth: 2
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 568.703,
    y1: 379.348,
    x2: 568.703,
    y2: 460.866,
    stroke: "#404040",
    strokeWidth: 2
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 568.639,
    y1: 459.866,
    x2: 777.202,
    y2: 459.866,
    stroke: "#404040",
    strokeWidth: 2
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 776.202,
    y1: 459.094,
    x2: 776.202,
    y2: 337.704,
    stroke: "#404040",
    strokeWidth: 2
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 775.331,
    y1: 338.703,
    x2: 693.963,
    y2: 338.703,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 645.395,
    y: 394.525,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 671.582,
    y: 400.728,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 679.935,
    y1: 427.854,
    x2: 695.834,
    y2: 427.854,
    stroke: "#404040",
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M694.899 338.779C694.899 367.609 673.962 378.495 672.453 378.462",
    stroke: "#404040",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M735.18 425.538H775.266V458.094H735.18V425.538Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M758.882 436.54H759.069V438.38H758.882C757.733 438.38 756.772 438.567 755.999 438.942C755.226 439.31 754.612 439.806 754.159 440.431C753.706 441.048 753.378 441.743 753.175 442.517C752.979 443.29 752.882 444.075 752.882 444.872V447.38C752.882 448.138 752.972 448.81 753.151 449.396C753.331 449.974 753.577 450.462 753.89 450.86C754.202 451.259 754.554 451.56 754.944 451.763C755.343 451.966 755.757 452.067 756.187 452.067C756.687 452.067 757.132 451.974 757.522 451.786C757.913 451.591 758.241 451.321 758.507 450.978C758.78 450.626 758.987 450.212 759.128 449.735C759.269 449.259 759.339 448.735 759.339 448.165C759.339 447.657 759.276 447.169 759.151 446.7C759.026 446.224 758.835 445.802 758.577 445.435C758.319 445.06 757.995 444.767 757.604 444.556C757.222 444.337 756.765 444.228 756.233 444.228C755.632 444.228 755.069 444.376 754.546 444.673C754.03 444.962 753.604 445.345 753.269 445.821C752.94 446.29 752.753 446.802 752.706 447.356L751.558 447.345C751.667 446.47 751.87 445.724 752.167 445.106C752.472 444.481 752.847 443.974 753.292 443.583C753.745 443.185 754.249 442.896 754.804 442.716C755.366 442.528 755.96 442.435 756.585 442.435C757.437 442.435 758.171 442.595 758.788 442.915C759.405 443.235 759.913 443.665 760.312 444.204C760.71 444.735 761.003 445.337 761.19 446.009C761.386 446.673 761.483 447.356 761.483 448.06C761.483 448.864 761.37 449.618 761.144 450.321C760.917 451.024 760.577 451.642 760.124 452.173C759.679 452.704 759.128 453.118 758.472 453.415C757.815 453.712 757.054 453.86 756.187 453.86C755.265 453.86 754.46 453.673 753.772 453.298C753.085 452.915 752.515 452.407 752.062 451.774C751.608 451.142 751.269 450.438 751.042 449.665C750.815 448.892 750.702 448.106 750.702 447.31V446.29C750.702 445.087 750.823 443.907 751.065 442.751C751.308 441.595 751.726 440.548 752.319 439.61C752.921 438.673 753.753 437.927 754.815 437.372C755.878 436.817 757.233 436.54 758.882 436.54Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M654.036 331.506C654.202 331.95 654.372 332.756 654.529 333.91C654.682 335.041 654.814 336.438 654.926 338.021C655.151 341.185 655.296 345.048 655.389 348.935C655.554 355.843 655.555 362.787 655.553 365.943H649.96C649.961 363.182 649.953 356.87 649.826 350.583C649.752 346.963 649.639 343.341 649.463 340.406C649.375 338.939 649.271 337.633 649.147 336.579C649.027 335.558 648.879 334.676 648.672 334.123C647.354 330.601 645.419 327.395 642.975 324.69C640.531 321.985 637.623 319.833 634.416 318.362C631.208 316.892 627.766 316.133 624.286 316.133C620.807 316.133 617.365 316.892 614.157 318.362C610.949 319.833 608.042 321.985 605.597 324.69C603.153 327.395 601.219 330.601 599.901 334.123C599.694 334.676 599.545 335.558 599.426 336.579C599.302 337.633 599.198 338.939 599.11 340.406C598.934 343.341 598.821 346.963 598.747 350.583C598.619 356.87 598.612 363.182 598.612 365.943H593.02C593.018 362.787 593.019 355.843 593.184 348.935C593.277 345.048 593.422 341.185 593.647 338.021C593.759 336.438 593.891 335.041 594.044 333.91C594.2 332.756 594.37 331.95 594.537 331.506C596.163 327.16 598.545 323.217 601.542 319.9C604.539 316.584 608.091 313.959 611.992 312.171C615.894 310.382 620.071 309.463 624.286 309.463C628.502 309.463 632.679 310.382 636.58 312.171C640.482 313.959 644.034 316.584 647.031 319.9C650.028 323.217 652.409 327.16 654.036 331.506Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M648.96 335.197C645.876 331.784 640.788 327.876 636.759 326.028C632.729 324.181 627.834 323.501 623.472 323.501C619.11 323.501 614.791 324.452 610.762 326.299C606.732 328.147 602.697 331.784 599.613 335.197",
    stroke: "#404040",
    strokeWidth: 2
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 598.664,
    y1: 365.943,
    x2: 649.909,
    y2: 365.943,
    stroke: "#404040",
    strokeWidth: 2
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 569.573,
    y1: 656.572,
    x2: 674.322,
    y2: 656.572,
    stroke: "#404040",
    strokeWidth: 2
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 570.573,
    y1: 657.572,
    x2: 570.573,
    y2: 739.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 570.509,
    y1: 738.09,
    x2: 779.072,
    y2: 738.09,
    stroke: "#404040",
    strokeWidth: 2
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 778.072,
    y1: 737.317,
    x2: 778.072,
    y2: 615.927,
    stroke: "#404040",
    strokeWidth: 2
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 777.201,
    y1: 616.927,
    x2: 695.834,
    y2: 616.927,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 647.265,
    y: 672.749,
    width: 21.3815,
    height: 38.7589,
    rx: 2,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 673.452,
    y: 678.951,
    width: 32.6046,
    height: 21.0376,
    rx: 3,
    stroke: "#404040",
    strokeWidth: 2
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 681.805,
    y1: 706.077,
    x2: 697.704,
    y2: 706.077,
    stroke: "#404040",
    strokeWidth: 4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M696.769 616.813C696.769 645.643 675.831 656.719 674.322 656.686",
    stroke: "#404040",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M737.05 703.761H777.137V736.317H737.05V703.761Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M766.265 715.673V716.892L759.198 732.736H756.913L763.968 717.454H754.733V715.673H766.265Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M655.906 609.729C656.073 610.174 656.243 610.979 656.399 612.133C656.552 613.265 656.684 614.662 656.796 616.244C657.021 619.408 657.166 623.272 657.259 627.159C657.424 634.066 657.425 641.011 657.423 644.167H651.831C651.831 641.406 651.824 635.094 651.696 628.806C651.622 625.186 651.509 621.565 651.333 618.629C651.245 617.163 651.141 615.856 651.017 614.802C650.897 613.782 650.749 612.9 650.542 612.346C649.224 608.824 647.29 605.618 644.845 602.913C642.401 600.208 639.494 598.056 636.286 596.586C633.078 595.115 629.636 594.357 626.157 594.357C622.677 594.357 619.235 595.115 616.027 596.586C612.819 598.056 609.912 600.208 607.468 602.913C605.023 605.618 603.089 608.824 601.771 612.346C601.564 612.9 601.416 613.782 601.296 614.802C601.172 615.856 601.068 617.163 600.98 618.629C600.804 621.565 600.691 625.186 600.617 628.806C600.49 635.094 600.482 641.406 600.483 644.167H594.89C594.889 641.011 594.889 634.066 595.054 627.159C595.147 623.272 595.292 619.408 595.517 616.244C595.629 614.662 595.761 613.265 595.914 612.133C596.07 610.979 596.24 610.174 596.407 609.729C598.033 605.383 600.415 601.441 603.412 598.124C606.409 594.807 609.961 592.183 613.863 590.394C617.764 588.606 621.941 587.687 626.157 587.687C630.372 587.687 634.549 588.606 638.45 590.394C642.352 592.183 645.904 594.807 648.901 598.124C651.898 601.441 654.28 605.383 655.906 609.729Z",
    stroke: "#404040",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M650.83 613.421C647.746 610.007 642.659 606.099 638.629 604.252C634.599 602.405 629.704 601.725 625.342 601.725C620.981 601.725 616.661 602.676 612.632 604.523C608.602 606.37 604.567 610.007 601.483 613.421",
    stroke: "#404040",
    strokeWidth: 2
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 600.534,
    y1: 644.167,
    x2: 651.78,
    y2: 644.167,
    stroke: "#404040",
    strokeWidth: 2
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 133.931,
    y2: -1.5,
    transform: "matrix(-0.956694 0.291096 -0.321054 -0.947061 404.968 763.013)",
    stroke: "#404040",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 111,
    width: 140,
    height: 41,
    rx: 9,
    stroke: "#404040",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 164,
    width: 140,
    height: 63,
    rx: 12,
    stroke: "#404040",
    strokeWidth: 2
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 586,
    y1: 143,
    x2: 586,
    y2: 176,
    stroke: "#404040",
    strokeWidth: 2
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 615,
    y1: 151,
    x2: 615,
    y2: 165,
    stroke: "#404040",
    strokeWidth: 2
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 151,
    x2: 700,
    y2: 165,
    stroke: "#404040",
    strokeWidth: 2
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 726,
    y1: 143,
    x2: 726,
    y2: 176,
    stroke: "#404040",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M692 186H726V215H692V186Z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M706.16 201.879L704.426 201.434L705.281 192.938H714.035V194.941H707.121L706.605 199.582C706.918 199.402 707.312 199.234 707.789 199.078C708.273 198.922 708.828 198.844 709.453 198.844C710.242 198.844 710.949 198.98 711.574 199.254C712.199 199.52 712.73 199.902 713.168 200.402C713.613 200.902 713.953 201.504 714.188 202.207C714.422 202.91 714.539 203.695 714.539 204.562C714.539 205.383 714.426 206.137 714.199 206.824C713.98 207.512 713.648 208.113 713.203 208.629C712.758 209.137 712.195 209.531 711.516 209.812C710.844 210.094 710.051 210.234 709.137 210.234C708.449 210.234 707.797 210.141 707.18 209.953C706.57 209.758 706.023 209.465 705.539 209.074C705.062 208.676 704.672 208.184 704.367 207.598C704.07 207.004 703.883 206.309 703.805 205.512H705.867C705.961 206.152 706.148 206.691 706.43 207.129C706.711 207.566 707.078 207.898 707.531 208.125C707.992 208.344 708.527 208.453 709.137 208.453C709.652 208.453 710.109 208.363 710.508 208.184C710.906 208.004 711.242 207.746 711.516 207.41C711.789 207.074 711.996 206.668 712.137 206.191C712.285 205.715 712.359 205.18 712.359 204.586C712.359 204.047 712.285 203.547 712.137 203.086C711.988 202.625 711.766 202.223 711.469 201.879C711.18 201.535 710.824 201.27 710.402 201.082C709.98 200.887 709.496 200.789 708.949 200.789C708.223 200.789 707.672 200.887 707.297 201.082C706.93 201.277 706.551 201.543 706.16 201.879Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M601.636 121.604V129H600.364V121.604H601.636ZM600.269 119.642C600.269 119.437 600.33 119.263 600.453 119.122C600.581 118.981 600.768 118.91 601.014 118.91C601.255 118.91 601.44 118.981 601.567 119.122C601.7 119.263 601.766 119.437 601.766 119.642C601.766 119.838 601.7 120.006 601.567 120.147C601.44 120.284 601.255 120.353 601.014 120.353C600.768 120.353 600.581 120.284 600.453 120.147C600.33 120.006 600.269 119.838 600.269 119.642Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M644.234 203.6H665.767C666.638 203.6 667.383 203.29 668.003 202.67C668.623 202.049 668.933 201.304 668.933 200.433V186.5C668.933 185.629 668.623 184.884 668.003 184.264C667.383 183.644 666.638 183.334 665.767 183.334H644.234C643.363 183.334 642.617 183.644 641.997 184.264C641.377 184.884 641.067 185.629 641.067 186.5V200.434C641.067 201.304 641.377 202.05 641.997 202.67C642.617 203.29 643.363 203.6 644.234 203.6ZM643.6 186.5C643.6 186.329 643.663 186.18 643.788 186.055C643.914 185.93 644.062 185.867 644.234 185.867H665.766C665.938 185.867 666.087 185.93 666.212 186.055C666.337 186.18 666.4 186.329 666.4 186.5V200.434C666.4 200.605 666.337 200.754 666.212 200.879C666.087 201.004 665.938 201.067 665.766 201.067H644.233C644.062 201.067 643.913 201.004 643.788 200.879C643.663 200.753 643.6 200.605 643.6 200.434V186.5Z",
    fill: "#404040"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M670.833 204.867H639.167H636V206.767C636 207.295 636.31 207.743 636.93 208.112C637.551 208.482 638.296 208.667 639.167 208.667H670.833C671.704 208.667 672.449 208.482 673.07 208.112C673.69 207.743 674 207.295 674 206.767V204.867H670.833V204.867ZM656.583 206.767H653.417C653.206 206.767 653.1 206.661 653.1 206.45C653.1 206.239 653.206 206.133 653.417 206.133H656.583C656.794 206.133 656.9 206.239 656.9 206.45C656.9 206.661 656.794 206.767 656.583 206.767Z",
    fill: "#404040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingMapStandart);
export default __webpack_public_path__ + "static/media/BookingMapStandart.1f29ebe488a7288d77f4b68cafdb9195.svg";
export { ForwardRef as ReactComponent };